import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useBattery');

    return {
        BATTERY_NAME_DUPLICATE_ERROR: t('batteryNameDuplicateError'),
        CONNECTION_ERROR: t('connectionError'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
